export default __webpack_public_path__ + "static/media/subscribed_user_dashboard_schedule_appointment.1d949ae5.svg";